
import chain from '@/lib/axios-chain'
// 获取组织和项目默认列表数据
export const orgIndex = () => chain.create('/user/organize/index', 'get')

// 创建组织
export const createOrgItem = () =>
  chain.create('/user/organize/createorg', 'post')
// 修改组织名称
export const editOrgName = () =>
  chain.create('/user/organize/modifyorgname', 'post')
// 转让组织第一步
export const tranfOrgFirst = () =>
  chain.create('/user/organize/transfercheck', 'post')
// 转让组织第二步
export const tranfOrgSecond = () =>
  chain.create('/user/organize/transferorg', 'post')
// 转让组织获取可选用户
export const tranfSelectDatas = () =>
  chain.create('/user/organize/transusers', 'get')

// 解散组织
export const dismissOrg = () =>
  chain.create('/user/organize/disbandorg', 'post')

// 获取项目列表
export const fetchProjectList = () =>
  chain.create('/user/organize/getProjectsByCid', 'get')

// 获取组织信息
export const fetchOrgDetail = () =>
  chain.create('/user/organize/orgdetail', 'get')

// 创建项目
export const createProject = () =>
  chain.create('/user/project/createpro', 'post')
// 修改项目名称
export const editProjectName = () =>
  chain.create('/user/project/modifyprojectname', 'post')
// 删除项目
export const delProject = () => chain.create('/user/project/deletepro', 'post')

// 关闭项目
export const closeProject = () => chain.create('/user/project/closepro', 'post')
// 打开项目
export const openProject = () => chain.create('/user/project/reopenpro', 'post')

// 创建项目时，获取管理员列表数据
export const getAdminId = () => chain.create('/user/project/createprousers', 'get')

// 人员管理获取管理员或者成员列表
export const getMemberListData = () =>
  chain.create('/user/organize/memberlist', 'get')

// 人员管理获取管理员或者成员详情
export const getMemberInfoData = () =>
  chain.create('/user/organize/memberdetail', 'get')

// 人员管理编辑管理员弹窗列表数据
export const editadminlist = () =>
  chain.create('/user/organize/editadminlist', 'get')

// 人员管理编辑管理员选择管理表单提交
export const editadminSub = () =>
  chain.create('/user/organize/editadmin', 'post')

// 人员管理详情页面删除人员
export const infoDelPerson = () =>
  chain.create('/user/organize/delmember', 'post')

// 项目跳转页面
export const projectTo = () => chain.create('/user/organize/choose', 'post')

// 邀请管理人员邮箱已存在验证
export const inviteEmailValid = () =>
  chain.create('/user/invite/emailisreg', 'post')

// 邀请管理人员
export const inviteAdmin = () =>
  chain.create('/user/invite/sendinviteadmins', 'post')

// 邀请加入获取公司信息
export const inviteGetComInfo = () =>
  chain.create('/user/invite/openinviteurl', 'get')

// 邀请后立即加入
export const inviteJoinFirst = () =>
  chain.create('/user/invite/regorlogin', 'post')

// 邀请最后一步加入邀请
export const inviteJoinLast = () =>
  chain.create('/user/invite/acceptinvite', 'post')

// 邀请完善信息
export const inviteInfoPerfect = () =>
  chain.create('/user/invite/supply', 'post')
// 获取企业微信信息
export const fetchQwDatas = () =>
  chain.create('/user/organize/installqw', 'get')

// 获取钉钉信息
export const fetchDdDatas = () =>
  chain.create('user/organize/installdt', 'get')
// 获取私有云信息
export const fetchcloudDatas = () =>
  chain.create('/private-cloud/config/config', 'post')
// 获取私有token
export const getToken = () =>
  chain.create('/private-cloud/config/new-token', 'get')

// 私有云配置提交
export const saveCloud = () =>
  chain.create('/private-cloud/config/save', 'post')
  // 停止私有云服务
export const stopCloud = () =>
  chain.create('/private-cloud/config/stop', 'post')
  // 循环调取接口解密API
export const loopCloud = () =>
  chain.create('/private-cloud/config/decrypt', 'post')

// 获取组织架构归属
export const getOrgType = () => chain.create('/user/organize/orgdetail', 'get')

// 获取钉钉或者企业微信组织列表
export const getStructureList = () => chain.create('/user/organize/structurelist', 'get')

// 切换组织架构
export const setStructureStatus = () => chain.create('/user/organize/syncstructure', 'post')

// 设置或者取消管理
export const setAdmin = () => chain.create('/user/organize/setadmin ', 'post')
// 设置或者取消管理
export const cancelAdmin = () => chain.create('/user/organize/canceladmin ', 'post')
// 修改昵称
export const editTruename = () => chain.create('/user/organize/settruename', 'post')

// 星轨获取项目管理
export const getProjectType = () => chain.create('/user/organize/getProjectType', 'get')

// 星轨项目管理开关
export const setProjectType = () => chain.create('/user/organize/setProjectType', 'post')
